import { Actions, ToggleActiveStatus } from "@";

export const TableActions = ({ row, toggleActive }) => {
  return (
    <>
      {/* Actions component with no edit or delete options */}
      <Actions notEdit notDelete row={row} url="donors">
        <ToggleActiveStatus row={row} click={toggleActive} />
      </Actions>
    </>
  );
};
